/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseIconSetFragment, IconSetFragment, FullIconSetFragment} from '@amblique/contentful/app/contentful/fragments/icon-set';

/**
 * Get a single IconSet by ID (base - scalars only)
 */
export const getBaseIconSetById = gql`
  ${BaseIconSetFragment}

  query GetBaseIconSetById($id: String!, $locale: String!, $preview: Boolean) {
    iconSet(id: $id, locale: $locale, preview: $preview) {
      ...BaseIconSetFragment
    }
  }
`;

/**
 * Get a single IconSet by ID (standard - 1 level deep)
 */
export const getIconSetById = gql`
  ${IconSetFragment}

  query GetIconSetById($id: String!, $locale: String!, $preview: Boolean) {
    iconSet(id: $id, locale: $locale, preview: $preview) {
      ...IconSetFragment
    }
  }
`;

/**
 * Get a single IconSet by ID (full - 2 levels deep)
 */
export const getFullIconSetById = gql`
  ${FullIconSetFragment}

  query GetFullIconSetById($id: String!, $locale: String!, $preview: Boolean) {
    iconSet(id: $id, locale: $locale, preview: $preview) {
      ...FullIconSetFragment
    }
  }
`;

/**
 * Get all IconSet entries with pagination (base - scalars only)
 */
export const getBaseIconSets = gql`
  ${BaseIconSetFragment}

  query GetBaseIconSets(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [IconSetOrder]
    $where: IconSetFilter
    $preview: Boolean
  ) {
    iconSetCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseIconSetFragment
      }
    }
  }
`;

/**
 * Get all IconSet entries with pagination (standard - 1 level deep)
 */
export const getIconSets = gql`
  ${IconSetFragment}

  query GetIconSets(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [IconSetOrder]
    $where: IconSetFilter
    $preview: Boolean
  ) {
    iconSetCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...IconSetFragment
      }
    }
  }
`;

/**
 * Get all IconSet entries with pagination (full - 2 levels deep)
 */
export const getFullIconSets = gql`
  ${FullIconSetFragment}

  query GetFullIconSets(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [IconSetOrder]
    $where: IconSetFilter
    $preview: Boolean
  ) {
    iconSetCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullIconSetFragment
      }
    }
  }
`;
